import { createUseRecipeHook } from '@/style/utils/createUseRecipeHook';
import * as style from './Card.Inner.css';
import { RecipeVariants } from '@/style/utils/createRecipeObj';

export const useCardStyle = createUseRecipeHook(style.root);
export type CardStyleProps = RecipeVariants<typeof style.root>;
